import { Link } from "react-router-dom";
import { ArrowLeft, ShieldCheck } from "lucide-react";

export default function Refunds() {
  return (
    <div className="page fade-up" data-testid="refunds-page">
      <Link to="/" className="inline-flex items-center gap-1 text-sm text-zinc-500 py-3 hover:text-black">
        <ArrowLeft size={14} /> Voltar
      </Link>
      <article className="bg-white rounded-2xl border border-zinc-200 p-5 sm:p-6 mb-8">
        <header className="mb-4 pb-4 border-b border-zinc-100">
          <div className="text-[10px] uppercase tracking-[0.15em] text-[#c8102e] font-bold mb-1 flex items-center gap-1">
            <ShieldCheck size={12} /> ANGOLAUK+
          </div>
          <h1 className="font-display text-2xl sm:text-3xl font-extrabold leading-tight">Política de Reembolsos</h1>
        </header>
        <div className="text-sm text-zinc-700 leading-relaxed space-y-3">
          <p>Esta política aplica-se apenas aos <strong>destaques pagos</strong> de negócios e eventos. As publicações normais na ANGOLAUK+ continuam gratuitas.</p>

          <h2 className="font-display text-lg font-bold mt-6 mb-2 text-black">Cancelamento e reembolso</h2>
          <p>Um destaque é um serviço pago com data de início e fim.</p>
          <p><strong>Podes cancelar um destaque a qualquer momento</strong> contactando-nos em <a href="mailto:support@angolauk.co.uk" className="text-[#c8102e] underline">support@angolauk.co.uk</a>. Nesse caso:</p>
          <ul className="list-disc ml-5 space-y-1">
            <li><strong>Cancelamento nas primeiras 24 horas</strong> e o destaque ainda <strong>não</strong> foi exibido — reembolso integral.</li>
            <li><strong>Cancelamento após 24 horas</strong> ou depois de o destaque ter começado a ser exibido — reembolso proporcional aos dias completos ainda por decorrer, arredondado para o dia útil seguinte. Os dias em que o destaque já foi exibido não são reembolsados.</li>
          </ul>

          <h2 className="font-display text-lg font-bold mt-6 mb-2 text-black">Terás direito a reembolso nos seguintes casos</h2>
          <ol className="list-decimal ml-5 space-y-1">
            <li>Cobrança duplicada.</li>
            <li>Falha técnica da ANGOLAUK+ que impeça o destaque de aparecer durante ≥ 24 h consecutivas.</li>
            <li>Remoção do anúncio pela moderação da ANGOLAUK+ durante o período pago — reembolso proporcional dos dias não usufruídos.</li>
          </ol>
          <p className="text-xs text-zinc-500">O processamento final do reembolso é feito manualmente pela equipa da ANGOLAUK+ através do Stripe.</p>

          <p>Estes direitos aplicam-se em acumulação com quaisquer direitos que a lei do consumidor no Reino Unido te confira, que permanecem inalterados.</p>

          <p>Para qualquer questão relacionada com pagamentos ou reembolsos, contacta <a href="mailto:support@angolauk.co.uk" className="text-[#c8102e] underline">support@angolauk.co.uk</a>.</p>
        </div>
        <p className="mt-6 pt-4 border-t border-zinc-100 text-[11px] text-zinc-500 leading-relaxed">
          Operado por CD NOIR LTD, sociedade registada em Inglaterra e País de Gales, número 17360692.
        </p>
      </article>
    </div>
  );
}
